var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconExportExcel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-export-excel_svg__icon-export-excel_svg__Canvas",
    transform: "translate(-35 -643)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-export-excel_svg__icon-export-excel_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-export-excel_svg__icon-export-excel_svg__Rectangle-path"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-export-excel_svg__icon-export-excel_svg__path0_fill",
    transform: "translate(52.6181 647.366)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icon-export-excel_svg__icon-export-excel_svg__Shape"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon-export-excel_svg__icon-export-excel_svg__path1_fill",
    transform: "translate(35.3608 643.118)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon-export-excel_svg__icon-export-excel_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 0 0L 5.75241 0L 5.75241 16.9935L 0 16.9935L 0 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-export-excel_svg__icon-export-excel_svg__path1_fill",
    fillRule: "evenodd",
    d: "M 0 21.2418L 16.1068 25.4902L 16.1068 0L 0 4.24837L 0 21.2418ZM 4.02669 7.08063L 6.58652 7.08063L 8.02462 10.2244L 9.52025 7.08063L 12.0225 7.08063L 9.4052 11.5839L 12.2814 16.8802L 9.72158 16.8802L 8.02462 13.1416L 6.35642 16.8802L 3.85412 16.8802L 6.64404 11.6689L 4.02669 7.08063Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExportExcel);
export default __webpack_public_path__ + "static/media/icon-export-excel.e059f431c6c451dfb0b35df6fd28ece3.svg";
export { ForwardRef as ReactComponent };